import request from '@/utils/request';
import {
  getQwEnv,
  getQwSseEnv,
  sortASCII,
  oauthLoginApi,
  getQwSignatureApi,
  getUserInfoApi,
} from '@/api/vipGiftRecommend';

/** 企微侧历史消息检测（SSE token、首屏话术）；MCP 手游/VIP OpenAPI 未收录，字段以后端为准 */
const QW_CHAT_DETECT_HISTORY_PATH = '/qy-weixin-chat/detect-history';
const RECOMMENDATION_EVENTS_PATH = '/qy-weixin-chat/recommendation/events';
const RECOMMENDATION_SESSION_REFRESH_PATH = '/qy-weixin-chat/recommendation/session/refresh';

function rejectBusinessError(response) {
  const data = response && response.data;
  if (data && Number(data.ret) === 0) {
    const error = new Error(data.msg || 'recommendation request failed');
    error.response = response;
    return Promise.reject(error);
  }
  return data;
}

/** 获取当前会话历史推荐、页面会话令牌和 SSE 初始化数据。 */
export async function qwChatDetectHistoryApi(params) {
  const response = await request({
    url: getQwEnv() + QW_CHAT_DETECT_HISTORY_PATH,
    method: 'post',
    data: sortASCII(params),
  });
  return rejectBusinessError(response);
}

/** 批量上报当前页面会话的推荐交互事件。 */
export async function recommendationEventsApi(params) {
  const response = await request({
    url: getQwEnv() + RECOMMENDATION_EVENTS_PATH,
    method: 'post',
    data: params,
  });
  return rejectBusinessError(response);
}

/** Refreshes the current page-session event token before it expires. */
export async function refreshRecommendationSessionApi(params) {
  const response = await request({
    url: getQwEnv() + RECOMMENDATION_SESSION_REFRESH_PATH,
    method: 'post',
    data: params,
  });
  return rejectBusinessError(response);
}

export {
  getQwEnv,
  getQwSseEnv,
  sortASCII,
  oauthLoginApi,
  getQwSignatureApi,
  getUserInfoApi,
};
